module.exports = __webpack_public_path__ + "img/board1-GPX-yellow-52.3f16ebcb.jpg";